import { createContext } from 'react';

export const CollaborationValuesContext = createContext({});

export default CollaborationValuesContext;
